import axios from '@/axios'
import authentication from '@/utilities/authentication'
import { EventBus } from '@/utilities/event-bus'

export default {
  login (cbOk, cbErr, username, password) {
    axios.post('/user/sessions.json', {email: username, password: password})
      .then(response => {
        this.setAuthentication(cbOk, cbErr, response)
      })
      .catch(err => {
        if (cbErr) cbErr(err)
      })
  },

  logout () {
    // we don't realy need to hit the API to sign out, all we have to do is forget our token
    authentication.clear()
    this.onChange(false)
  },

  loggedIn () {
    return (!!authentication.token() && !!authentication.username())
  },

  forgotPassword (cbOk, cbErr, username) {
    // NOTE: the route we build up here points to the Vue router entry: '/reset-password'.
    // The API will tack on a token, call back to Vue and that will present a form to capture the new password
    // NOTE: location.origin includes the protocol and port live http://example.com:1234
    axios.post('/user/password_resets.json', {email: username, redirect_url: location.origin + '/reset-password'})
      .then(response => {
        if (cbOk) cbOk(response)
      })
      .catch(err => {
        if (cbErr) cbErr(err)
      })
  },

  resetPassword (cbOk, cbErr, password, confirmation, token) {
    axios.put(`/user/password_resets/${token}.json`, {password: password, password_confirmation: confirmation})
      .then(response => {
        this.setAuthentication(cbOk, cbErr, response)
      })
      .catch(err => {
        if (cbErr) cbErr(err)
      })
  },

  setAuthentication (cbOk, cbErr, response) {
    response.data = response.data.data
    if (response.data && response.data.attributes.authentication_token) {
      authentication.token(response.data.attributes.authentication_token)
      authentication.username(response.data.attributes.email)
      authentication.instance(response.data)
      this.onChange(true)
      if (cbOk) cbOk(response.data)
    } else {
      this.onChange(false)
      if (cbErr) cbErr(response.error)
    }
  },

  onChange (status) {
    // whenever our login status changes, we need to clear the data stored
    EventBus.$emit('authenticated', status)
  }
}



// WEBPACK FOOTER //
// ./src/services/authentication.js